import { render, staticRenderFns } from "./WxIndex.vue?vue&type=template&id=c4f9e852&scoped=true&"
import script from "./WxIndex.vue?vue&type=script&lang=js&"
export * from "./WxIndex.vue?vue&type=script&lang=js&"
import style0 from "./WxIndex.vue?vue&type=style&index=0&id=c4f9e852&prod&lang=css&"
import style1 from "./WxIndex.vue?vue&type=style&index=1&id=c4f9e852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f9e852",
  null
  
)

export default component.exports